module.exports = __webpack_public_path__ + "img/83.9.TU.3a8b7584.png";